import React from "react";
import ReactApexChart from "react-apexcharts";
import "../CompanyNameChart/CompanyNameChart.css";

const CompanyNameChart = () => {
  // Updated data for Empty, Mismatched, and Perfect Companies
  const series = [50, 20, 70]; // Values for Empty, Mismatched, and Perfect Companies
  const options = {
    chart: {
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: "30%",
          background: "transparent",
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
        barLabels: {
          enabled: true,
          useSeriesColors: false,
          offsetX: -8,
          fontSize: "14px",
          color: "#999", // Set the label text color to #999
          // formatter: function (seriesName, opts) {
          //   return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
          // },
        },
      },
    },
    colors: ["#a5bcfc", "#c7d7fe", "#dcdcdc"], // Updated with your specific colors
    labels: ["Empty Company", "Mismatched Company", "Perfect Company"], // Updated labels
    tooltip: {
      enabled: true,
      formatter: function (val, { seriesIndex }) {
        const label = options.labels[seriesIndex];
        return `${label}: ${val}%`;
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  return (
    <>
      <section className="section">
        <div className="company-container">
          <div className="company-header">
            <h1>Company Name Categories</h1>
          </div>

          <div className="company-parent">
            <div className="company-count-wrapper">
              <div>
                <i class="fa-solid fa-circle" style={{ color: "#a5bcfc" }}></i>{" "}
                Empty
              </div>
              <div>
                <i class="fa-solid fa-circle" style={{ color: "#c7d7fe" }}></i>{" "}
                Mismatched
              </div>
              <div>
                <i class="fa-solid fa-circle" style={{ color: "#dcdcdc" }}></i>{" "}
                Perfect
              </div>
            </div>

            <div className="company-chart-container">
              <ReactApexChart
                options={options}
                series={series}
                type="radialBar"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CompanyNameChart;
